export default __webpack_public_path__ + "static/media/final-assessment-icon.b2d63161.svg";